<template>
  <div class="product-details" style="width: 100%">
    <div v-if="bundle">
      <v-container style="max-width: 1170px">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" md="5" sm="12">
            <div v-if="bundle.additionalValue" style="text-align-last: right">
              <v-chip
                style="color: white"
                color="#ea412a"
                large
                class="product-discount-tag"
                label
              >
                <span> {{ bundle.additionalValue }} % </span>
              </v-chip>
            </div>
            <div
              style="max-width: 370px"
              class="hover-hand"
              @click="productImageDialog = true"
            >
              <v-img
                :src="bundle.imgUrl"
                class="mx-auto hover-hand"
                lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
                transition="fade-transition"
                width="370"
                height="370"
              />
            </div>
          </v-col>
          <v-col>
            <div class="brands_series__title"></div>
            <div class="font-weight-bold mt-3" style="font-size: 20px">
              {{ bundle.campaignName }}
            </div>
            <div
              class="my-3 pr-5"
              style="display: flex; align-items: center; justify-content: start"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    size="16"
                    :color="selectedBundleDuration.alert ? 'red' : ''"
                  >
                    schedule
                  </v-icon>
                </template>
                <span>Pakketilbud tilgjengelig til</span>
              </v-tooltip>
              <span
                style="text-transform: capitalize"
                :style="{
                  color: selectedBundleDuration.alert ? 'red' : '',
                }"
                >{{ selectedBundleDuration.time }}</span
              >
            </div>
            <div :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-flex align-end'">
              <div class="d-flex flex-column">
                <div class="" v-if="bundle.totalValue === bundle.campaignValue">
                  <span class="font-weight-regular">kr </span>
                  <span class="font-weight-medium" style="font-size: 30px"
                    >{{ bundle.totalValue | currency(2, 2) }}
                  </span>
                </div>
                <div class="d-flex flex-column" v-else>
                  <div>
                    <span
                      class="text-decoration-line-through font-weight-regular"
                      >kr
                      <small style="font-size: 20px"
                        >{{ bundle.totalValue | currency(2, 2) }}
                      </small></span
                    > <span v-if="bundle.lowestPrice != null"> Pris {{lowestPriceDate()}}: {{ bundle.lowestPrice | currency(2, 2) }} ({{ lowestPriceDiscount() }}%)</span>
                  </div>
                  <div style="color: red">
                    <span class="font-weight-regular">kr </span>
                    <span class="font-weight-medium" style="font-size: 30px"
                      >{{ bundle.campaignValue | currency(2, 2) }}
                    </span>
                  </div>
                </div>
              </div>
              <AddBundleToCartClickAndCollect
                :bundle="bundle"
                class="product__details__btn"
                :details="true"
              />
            </div>
            <small>
              <i>
                Endelig pris for dette produktet vil bli presentert i
                handlekurven. Den beste prisen vil bli valgt basert på de
                produktene du skal kjøpe.
              </i>
            </small>
            <div
              class="mt-5 primary--text d-flex flex-row"
              style="align-items: start"
            >
              <v-icon color="primary" class="pr-2">fxt-salon</v-icon>
              <div class="d-flex flex-column">
                <span
                  ><b>Hent på stedet:</b> På lager {{ salonsWithStock.length }}
                  {{ salonsWithStock.length === 1 ? "sted" : " steder" }}</span
                >
                <v-menu offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="primary"
                      class="primary--text"
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      outlined
                      small
                      style="max-width: 130px"
                    >
                      Vis steder
                      <v-icon>{{
                        attrs["aria-expanded"] == "true"
                          ? "fxt-chevron-up"
                          : "fxt-chevron-down"
                      }}</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="item in salonSorted"
                      :key="item.siteId"
                      link
                    >
                      <div
                        class="d-flex flex-row justify-space-between"
                        style="width: 100%"
                      >
                        <span class="pr-5">
                          {{ item.siteName }}
                        </span>
                        <div class="d-flex">
                          <span
                            :style="{
                              color: getBundleStockAmountForSite(item)
                                ? 'green'
                                : 'red',
                            }"
                          >
                            {{
                              getBundleStockAmountForSite(item)
                                ? "På lager"
                                : "Utsolgt"
                            }}
                          </span>
                          <v-icon
                            :color="
                              getBundleStockAmountForSite(item)
                                ? 'green'
                                : 'red'
                            "
                          >
                            {{
                              getBundleStockAmountForSite(item)
                                ? "fxt-check"
                                : "fxt-close"
                            }}
                          </v-icon>
                        </div>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div
              class="mt-5 primary--text d-flex flex-row"
              style="align-items: start"
              v-if="!noSalonHasHomeShipment"
            >
              <v-icon color="primary" class="pr-2">fxt-truck</v-icon>
              <div class="d-flex flex-column">
                <span
                  ><b>For hjemsending: </b>
                  {{
                    bundlesHomeshipmentStock > 0 ? "På lager" : "Ikke på lager"
                  }}</span
                >
              </div>
            </div>
            <div v-if="!noSalonHasHomeShipment" class="pt-5">
              <img class="pr-5" v-for="p in paymentMethods" :key="p" :src="p" />
            </div>
            <div class="mt-6">
              <v-tabs>
                <v-tab
                  disabled
                  class="font-weight-bold"
                  style="border-bottom: 2px solid var(--v-primary-base)"
                  ><span style="font-size: 20px; color: black"
                    >Beskrivelse</span
                  ></v-tab
                >
              </v-tabs>
              <v-divider style="height: 10px !important" />
              <div class="pt-2" v-html="bundle.information"></div>
            </div>
            <div class="mt-7" v-if="!$wait.is('loading webshop getProducts')">
              <div class="font-weight-bold" style="font-size: 20px">
                Produkter i pakken ({{ bundleProducts.length }})
              </div>
              <v-divider style="height: 10px !important" />
              <v-card
                v-if="productIndex <= bundleProducts.length"
                v-for="productIndex in productsToShow"
                elevation="1"
                class="grey lighten-3 mb-3 pa-0 mt-3"
                max-height="70px"
                :key="productIndex"
              >
                <div class="d-flex justify-space-between pa-3 align-center">
                  <div style="height: 50px; width: 60px">
                    <v-img
                      :src="bundleProducts[productIndex - 1].imgUrl"
                      class="mx-auto hover-hand"
                      lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
                      transition="fade-transition"
                      width="50"
                    />
                  </div>
                  <span
                    style="width: 50%"
                    class="font-weight-bold bundle-product__title"
                    v-if="bundleProducts[productIndex - 1].quantity == 1"
                  >
                    {{ bundleProducts[productIndex - 1].title }}
                  </span>
                  <span
                    style="width: 50%"
                    class="font-weight-bold bundle-product__title"
                    v-if="bundleProducts[productIndex - 1].quantity > 1"
                  >
                    {{ bundleProducts[productIndex - 1].title }} (x{{
                      bundleProducts[productIndex - 1].quantity
                    }})
                  </span>
                  <div class="align-self-center">
                    <span class="font-weight-regular">kr </span>
                    <span class="font-weight-medium">{{
                      bundleProducts[productIndex - 1].productDetails.price
                        | currency(2, 2)
                    }}</span>
                  </div>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      goToProductDetails(bundleProducts[productIndex - 1])
                    "
                  >
                    Gå til
                  </v-btn>
                </div>
              </v-card>
              <div
                style="width: 100%"
                class="d-flex justify-center"
                v-if="productsToShow < bundleProducts.length"
              >
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  @click="productsToShow = bundleProducts.length"
                >
                  Se alle
                </v-btn>
              </div>
            </div>
            <div
              v-if="$wait.is('loading webshop getProducts')"
              class="mx-auto mt-8 text-center"
            >
              <v-progress-circular
                indeterminate
                size="50"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="mx-8 mt-5" />
      <!-- <product-suggestions
        class="mx-5"
        suggestion-text="Kjøpt sammen med"
        suggestions-for="productDetailsPage"
      /> -->

      <!--<CampaignsBundleCarousel class="mx-5" />-->

      <RecommendationBox
        class="my-4"
        :userId="this.$user.onlineSluttKundeId"
        presentation="grid"
        :itemQty="4"
        :itemType="itemType.P"
        :chainId="parseInt(this.$route.params.chainId)"
        :location="location.PRODUCT_PAGE"
        :channel="channel.Nettbutik"
        :productIds="base64Ids"
        :urlBase="urlBase"
        @cardClick="goToProductDetailsRec"
        @buttonClick="addBtnActionRec"
        :cartItemsIds="cartItemIds"
      >
      </RecommendationBox>
      <v-dialog v-model="productImageDialog" max-width="550">
        <v-card>
          <campaign-img
            :campaign="bundle"
            :type="imageTypes.Campaign"
            :id="bundle.imageUrl > 0 ? bundle.campaignId : 0"
            :height="490"
            :width="370"
            :imageVersion="bundle.imageUrl"
            :aspectRatio="1 / 1"
            fileType="png"
          ></campaign-img>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-overlay absolute :value="$wait.is('loading webshop getProductsByIds')">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import { AddBundleToCartClickAndCollect } from "@/components/webshop";
import CampaignImg from "@/components/CampaignImage";
import imageTypes from "@/constants/image-types";
import { waitFor } from "vue-wait";
import CampaignsBundleCarousel from "../components/CampaignsBundleCarousel.vue";
import { mapWaitingActions } from "vue-wait";
import RecommendationBox from "@fixit/v-recommendation-box";

import visa from "@/assets/payment-methods/logo_visa.png";
import mastercard from "@/assets/payment-methods/logo_mastercard.png";
import klarna from "@/assets/payment-methods/logo_klarna.png";
import vipps from "@/assets/payment-methods/logo_vipps.png";
import apple_pay from "@/assets/payment-methods/logo_apple_pay.png";
import google_pay from "@/assets/payment-methods/logo_google_pay.png";
import {
  ItemType,
  Location,
  Channel,
} from "@fixit/v-recommendation-box/src/enums";

export default {
  name: "product-details",
  components: {
    CampaignsBundleCarousel,
    AddBundleToCartClickAndCollect,
    CampaignImg,
    RecommendationBox,
  },
  mixins: [webshopMixins],
  data() {
    return {
      imageTypes,
      bundle: null,
      productsToShow: 6,
      totalProducts: 0,
      galleryPreviewDialog: false,
      bundleProducts: [],
      productImageDialog: false,
      paymentMethods: [visa, mastercard, vipps, klarna, apple_pay, google_pay],
      base64Ids: [],
      itemType: ItemType,
      location: Location,
      channel: Channel,
    };
  },
  methods: {
    // ...mapWaitingActions("webshop", {
    //   getProductsByIds: "loading webshop getProducts"
    // }),
    ...mapWaitingActions("campaigns", {
      getCampaingsByFilter: "loading campaigns getCampaingsByFilter",
    }),
    lowestPriceDate() {
      return this.$moment(this.bundle.dateOfLowestPrice).format("DD.MM");
    },
    lowestPriceDiscount(){
     return Math.ceil((((this.bundle.totalValue-this.bundle.lowestPrice)/this.bundle.totalValue)*100))
    },
    async addBtnActionRec(item) {
      var link = item.urlSafe.split("/");
      var product = await this.$store.dispatch("webshop/getProductsByIds", {
        avoidCache: true,
        chainId: parseInt(this.$route.params.chainId),
        includeCampaignProducts: true,
        isBase64: true,
        productIds: [link[1]],
      });
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product[0],
      });
      this.addProductToSalonCart(this.salons[0]);
    },
    getCategoryName(categoryId) {
      let category = this.mappedCategories.find(
        (x) => x.webshopCategoryId === categoryId
      );
      return category ? category.title : "";
    },
    getMainCatgory(categoryId) {
      return this.mappedCategories.find((x) =>
        x.children.includes(
          this.allChildCategories.find(
            (x) => x.webshopCategoryId === categoryId
          )
        )
      )
        ? this.mappedCategories.find((x) =>
            x.children.includes(
              this.allChildCategories.find(
                (x) => x.webshopCategoryId === categoryId
              )
            )
          )
        : this.mappedCategories.find((x) => x.webshopCategoryId === categoryId);
    },
    getCategoryFirst(categoryId) {
      let category = this.mappedCategories.find((x) =>
        x.children.includes(
          this.allChildCategories.find(
            (x) => x.webshopCategoryId === categoryId
          )
        )
      )
        ? this.mappedCategories.find((x) =>
            x.children.includes(
              this.allChildCategories.find(
                (x) => x.webshopCategoryId === categoryId
              )
            )
          )
        : this.mappedCategories.find((x) => x.webshopCategoryId === categoryId);

      return this.categories.find((x) => x.children.includes(category))
        .urlSafeTitle;
    },
    goToCategory(category) {
      this.$router
        .push({
          name: "webshopChainProductsMainCategories",
          params: { categoryFirst: category },
          query:
            this.getMainCatgory(this.product.categoryId).webshopCategoryId ===
            this.product.categoryId
              ? { category: this.product.categoryId.toString() }
              : {
                  category: this.product.categoryId.toString(),
                  mCategory: this.getMainCatgory(this.product.categoryId)
                    .urlSafeTitle,
                },
        })
        .catch(() => {});
    },
  },
  computed: {
    noSalonHasHomeShipment() {
      return this.salons.filter((x) => x.homeShipmentEnabled).length === 0;
    },
    salonSorted() {
      return this.salons
        .slice()
        .sort((a, b) =>
          this.getBundleStockAmountForSite(a) <
          this.getBundleStockAmountForSite(b)
            ? 1
            : -1
        );
    },
    salonsWithStock() {
      return this.salons.filter((salon) => {
        return this.getBundleStockAmountForSite(salon);
      });
    },
    bundlesHomeshipmentStock() {
      //bundles is from webshop.mixin.js. Checks homeShipmentEnabled per site and checks stock.
      return this.bundles.length
        ? this.bundles.find((x) => x.campaignId === this.bundle.campaignId)
            .stockForDelivery
        : 0;
    },
    outOfStock() {
      return !this.product.productDetails.inventory.length;
    },

    cartProduct() {
      return this.cartItems.find((x) => x.id === this.product.id);
    },

    allChildCategories() {
      let children = [];
      this.mappedCategories.forEach((c) => {
        c.children.forEach((ch) => {
          children.push(ch);
        });
      });
      return children;
    },
  },
  beforeDestroy() {
    this.$store.dispatch("webshop/set", { key: "selectedBundle", value: null });
  },
  watch: {
    galleryPreviewDialog: {
      handler(val) {
        this.$nextTick(() => {
          let player = document.getElementById("gallery-video");
          if (player) {
            if (val) player.play();
            else player.pause();
          }
        });
      },
    },
    "$route.params.campaignId": {
      async handler(val) {
        this.bundle = null;
        waitFor(`loading webshop getProductsByIds`, async function () {
          // let allBundles = this.$store.getters["campaigns/get"](
          //   "campaigns"
          // ).filter((c) => c.promotionType.promotionTypeName === "Bundle");
          // if (allBundles.length) {
          //   this.bundle = allBundles.find((b) => b.campaignId == val);
          // } else {
          await this.$store.dispatch(
            "campaigns/getCampaingsByFilter",
            this.currentChainId
          );
          this.bundle = await this.$store.dispatch("campaigns/fetchById", {
            campaignId: val,
            chainId: this.currentChainId,
            fetchProducts: {
              ...val.query,
              tCategory: this.categories.find(
                (c) => this.$route.params.categoryFirst === c.urlSafeTitle
              )?.title,
              chainId: this.currentChainId,
              itemsPerPage: this.itemsPerPage,
              avoidCache: true,
            },
          });
          // }
          this.$store.dispatch("webshop/set", {
            key: "selectedBundle",
            value: this.bundle,
          });
          this.$store.dispatch("campaigns/set", {
            key: "bundle",
            value: this.bundle,
          });
        }).apply(this);
      },
      immediate: true,
      deep: true,
    },
    bundle: {
      handler(val) {
        if (val) {
          waitFor(`loading webshop getProducts`, async function () {
            // let products = await this.$store.dispatch(
            //   "webshop/getProductsByIds",
            //   {
            //     chainId: this.currentChainId,
            //     productIds: val.producIds,
            //     isBase64: true,
            //   }
            // );
            this.totalProducts = val.products.length;
            this.bundleProducts = val.products;
            this.bundleProducts.forEach((x) => this.base64Ids.push(x.idBase64));
          }).apply(this);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.product__details__btn::v-deep {
  .v-btn {
    min-width: unset !important;
  }
}

.brands_series__title {
  line-height: 1;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.hover-hand {
  cursor: pointer;
}

.stock_salon__list {
  height: 100%;
  max-height: 115px;
  overflow-y: auto;
}

.price__box::v-deep {
  border-radius: 5px;

  .v-btn {
    padding: 15px !important;
    width: inherit !important;
    border-radius: 5px;
    height: 50px !important;
    //background-color: #7e697f !important;
  }

  .v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    color: black !important;
    //background-color: #7e697f !important;
  }
}

.bundle-product__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.v-tab--disabled {
  opacity: 1;
}

.v-tab {
  padding: 0;
  text-transform: capitalize;
}
</style>
